import { Config as PayloadConfig } from 'payload'

export type PluginOptions = {} & Pick<PayloadConfig, 'i18n'>

export type PackageManager = 'bun' | 'npm' | 'pnpm' | 'yarn'
